import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { CommercialConsultantService } from '../../../services/CommercialConsultant/CommercialConsultantService'
import { CommercialConsultant } from '../../../services/CommercialConsultant/types'

interface ICommercialConsultantDeleteDialogProps {
  isOpen: boolean
  onClose: () => void
  consultant: CommercialConsultant | null
  leastDestructiveRef: React.RefObject<HTMLButtonElement>
  onDelete: () => void
}

export default function CommercialConsultantDeleteDialog({
  isOpen,
  onClose,
  consultant,
  leastDestructiveRef,
  onDelete
}: ICommercialConsultantDeleteDialogProps) {
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()
  const service = new CommercialConsultantService()

  const handleDelete = async () => {
    if (!consultant) return
    setIsLoading(true)
    try {
      await service.delete(consultant.id)
      toast({ title: 'Consultor excluído com sucesso', status: 'success', duration: 3000, isClosable: true })
      onDelete()
    } catch {
      toast({ title: 'Erro ao excluir consultor', status: 'error', duration: 3000, isClosable: true })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          Remover consultor &quot;{consultant?.name}&quot;
        </AlertDialogHeader>
        <AlertDialogBody>Tem certeza que deseja fazer isso?</AlertDialogBody>
        <AlertDialogFooter>
          <Button onClick={onClose} variant="outline">
            Cancelar
          </Button>
          <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
            Sim
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
